import { NavBar } from "@components/ui-kit";
import { t } from "@lingui/macro";
import { useProjectNavigationPages } from "@src/components/widgets/AppSubNav/NavigationProject/hooks";
import { observer } from "mobx-react-lite";
import { AppSubNav } from "../AppSubNav";

interface NavigationProjectProps {
  id: string;
}
export const NavigationProject = observer(function NavigationProject({
  id,
}: NavigationProjectProps) {
  const { visiblePages } = useProjectNavigationPages(id);

  return (
    <AppSubNav
      showWidgets={false}
      zIndex="1"
      mobileMenuTitle={t`Pages`}
      hideNewTaskButton
    >
      {visiblePages.map((page) => (
        <NavBar.Item key={page.href.pathname} href={page.href}>
          {page.title()}
        </NavBar.Item>
      ))}
    </AppSubNav>
  );
});
